import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// third-party
import { Provider as ReduxProvider } from "react-redux";

// project-imports
import App from "./App";
import { ConfigProvider } from "contexts/ConfigContext";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";

// fonts
import "assets/fonts/inter/inter.css";
import "assets/general/common.css";

// scroll bar
// import "simplebar/dist/simplebar.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// apex-chart
import "assets/third-party/apex-chart.css";
import "assets/third-party/react-table.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

// Register service worker for PWA
if ("serviceWorker" in navigator) {
  window.addEventListener("load", function () {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(function (registration) {
        console.log(
          "ServiceWorker registration successful with scope: ",
          registration.scope
        );
      })
      .catch(function (err) {
        console.log("ServiceWorker registration failed: ", err);
      });
  });
}
const container = document.getElementById("root");
const root = createRoot(container);

// Create QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } }, // stop refresh on tab changes
});

root.render(
  <ReduxProvider store={store}>
    <ConfigProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter
          basename={process.env.REACT_APP_BASE_NAME}
          future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true,
          }}
        >
          <PersistGate loading={null} persistor={persistor}>
            {process.env.REACT_APP_NODE_ENV === "development" && (
              <ReactQueryDevtools initialIsOpen={false} position="bottom" />
            )}
            <App />
          </PersistGate>
        </BrowserRouter>
      </QueryClientProvider>
    </ConfigProvider>
  </ReduxProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
